import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { ImprintDialog, useImprintDialog } from './ImprintDialog';
import { PrivacyDialog, usePrivacyDialog } from './PrivacyDialog';
import { LegalDocuments, useLegalDocuments } from '../legal/LegalDocuments';

interface FooterLinksProps {
    extraLinks?: { label: string; to: string }[];
}

export function FooterLinks({ extraLinks }: FooterLinksProps) {
    const { imprintOpen, openImprint, closeImprint } = useImprintDialog();
    const { privacyOpen, openPrivacy, closePrivacy } = usePrivacyDialog();
    const { legalDocumentsOpen, openLegalDocuments, closeLegalDocuments } =
        useLegalDocuments();

    return (
        <>
            <Box
                sx={{
                    position: 'fixed',
                    bottom: 4,
                    right: 16,
                    fontSize: '0.8rem',
                    color: 'text.secondary',
                    opacity: 0.6,
                    display: 'flex',
                    gap: 1.5,
                    alignItems: 'center',
                }}
            >
                {extraLinks?.map((link) => (
                    <span key={link.to} style={{ display: 'contents' }}>
                        <Link to={link.to} style={{ textDecoration: 'none', color: 'inherit' }}>
                            {link.label}
                        </Link>
                        <Typography variant="body2" sx={{ fontSize: '0.8rem' }}>|</Typography>
                    </span>
                ))}
                <Typography
                    variant="body2"
                    sx={{
                        fontSize: '0.8rem',
                        cursor: 'pointer',
                        '&:hover': { opacity: 1 },
                    }}
                    onClick={openPrivacy}
                >
                    Privacy
                </Typography>
                <Typography variant="body2" sx={{ fontSize: '0.8rem' }}>|</Typography>
                <Typography
                    variant="body2"
                    sx={{
                        fontSize: '0.8rem',
                        cursor: 'pointer',
                        '&:hover': { opacity: 1 },
                    }}
                    onClick={openImprint}
                >
                    Imprint
                </Typography>
                <Typography variant="body2" sx={{ fontSize: '0.8rem' }}>|</Typography>
                {/* The terms a user accepted, to read again later. */}
                <Typography
                    variant="body2"
                    role="button"
                    tabIndex={0}
                    sx={{
                        fontSize: '0.8rem',
                        cursor: 'pointer',
                        '&:hover': { opacity: 1 },
                    }}
                    onClick={openLegalDocuments}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter' || event.key === ' ') {
                            event.preventDefault();
                            openLegalDocuments();
                        }
                    }}
                >
                    Legal
                </Typography>
            </Box>

            <ImprintDialog open={imprintOpen} onClose={closeImprint} />
            <PrivacyDialog open={privacyOpen} onClose={closePrivacy} />
            <LegalDocuments open={legalDocumentsOpen} onClose={closeLegalDocuments} />
        </>
    );
}